import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';

import actionTypes from '../types/actionTypes';

import 'style/layout/Buttons.css';

const ReAttachConnections = ({
  setActionType,
}: {
  setActionType: (actionType: string) => void;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);

  const reAttachConnections = () => {
    window.ReAttachConnections();
    setActionType(actionTypes.addWall);
  };

  return (
    <>
      <PrimaryButton className="button-long-text" onClick={reAttachConnections}>
        {t(`${translations.common}:Re-Attach Connections`).toLocaleUpperCase()}
      </PrimaryButton>
    </>
  );
};

export default ReAttachConnections;
